import * as plotUtil from '../plot_util'

function generatePoints(center, majorRadius, minorRadius) {
    let x, y, angle, points = [];
    for (let i = 0; i <= 100; i++) {
        angle = Math.PI * 2 * i / 100;
        x = center[0] + majorRadius * Math.cos(angle);
        y = center[1] + minorRadius * Math.sin(angle);
        points.push([plotUtil.mercatorToWGS([x, y])[0], plotUtil.mercatorToWGS([x, y])[1]]);
    }
    return points;
};

export default function (coordinates) {
    if (coordinates.length < 2) return [];
    let pnt1 = plotUtil.wgsToMercator(coordinates[0]);
    let pnt2 = plotUtil.wgsToMercator(coordinates[1]);
    let center = plotUtil.mid(pnt1, pnt2);
    let majorRadius = Math.abs((pnt1[0] - pnt2[0]) / 2);
    let minorRadius = Math.abs((pnt1[1] - pnt2[1]) / 2);
    return [generatePoints(center, majorRadius, minorRadius)];
}